<template>
  <div class="reload-container">
    <div class="message-box">
      <p class="message-text">Unable to load the funnel source, please reload the page</p>
      <button class="reload-btn" @click="reloadPage">
        Reload Page
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
const reloadPage = () => {
  window.location.reload();
};
</script>

<style scoped>
.reload-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  min-height: 200px;
  width: 100%;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
}

.message-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  text-align: center;
  padding: 2rem;
}

.message-text {
  font-size: 1.1rem;
  color: #666;
  margin: 0;
}

.reload-btn {
  background-color: #000;
  color: white;
  padding: 12px 24px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
}

.reload-btn:hover {
  background-color: #333;
  transform: translateY(-1px);
}

.reload-btn:active {
  transform: translateY(0);
}

/* Dark mode support if applicable */
@media (prefers-color-scheme: dark) {
  .message-text {
    color: #a1a1aa;
  }
  
  .reload-btn {
    background-color: #fff;
    color: #000;
  }
  
  .reload-btn:hover {
    background-color: #e4e4e7;
  }
}
</style>
